export default __webpack_public_path__ + "static/media/carzlook-app-icon.3ddf5724.jpg";